// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/unsubscribes/:email(.:format)`
 * - Path helper: `unsubscribe_path`
 * - URL helper: `unsubscribe_url`
 * - controller#action: `users/unsubscribes#show`
 *
 * @param {any} email
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribePath = /*#__PURE__*/ (...args) => {
  const _organizationUnsubscribePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"unsubscribes"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _unsubscribePath = /*#__PURE__*/ __jsr.r({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribes"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUnsubscribePath(gon.current_organization.path, ...args);
  }

  return _unsubscribePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/geo/sign_in(.:format)`
 * - Path helper: `users_auth_geo_sign_in_path`
 * - URL helper: `users_auth_geo_sign_in_url`
 * - controller#action: `sessions#new`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthGeoSignInPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthGeoSignInPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _usersAuthGeoSignInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersAuthGeoSignInPath(gon.current_organization.path, ...args);
  }

  return _usersAuthGeoSignInPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth/geo/sign_out(.:format)`
 * - Path helper: `users_auth_geo_sign_out_path`
 * - URL helper: `users_auth_geo_sign_out_url`
 * - controller#action: `sessions#destroy`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthGeoSignOutPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthGeoSignOutPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _usersAuthGeoSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"geo"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersAuthGeoSignOutPath(gon.current_organization.path, ...args);
  }

  return _usersAuthGeoSignOutPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/almost_there(.:format)`
 * - Path helper: `users_almost_there_path`
 * - URL helper: `users_almost_there_url`
 * - controller#action: `confirmations#almost_there`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAlmostTherePath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAlmostTherePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"almost_there"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersAlmostTherePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"almost_there"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersAlmostTherePath(gon.current_organization.path, ...args);
  }

  return _usersAlmostTherePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/resend_verification_code(.:format)`
 * - Path helper: `users_resend_verification_code_path`
 * - URL helper: `users_resend_verification_code_url`
 * - controller#action: `sessions#resend_verification_code`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersResendVerificationCodePath = /*#__PURE__*/ (...args) => {
  const _organizationUsersResendVerificationCodePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_verification_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersResendVerificationCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_verification_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersResendVerificationCodePath(gon.current_organization.path, ...args);
  }

  return _usersResendVerificationCodePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/successful_verification(.:format)`
 * - Path helper: `users_successful_verification_path`
 * - URL helper: `users_successful_verification_url`
 * - controller#action: `sessions#successful_verification`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSuccessfulVerificationPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSuccessfulVerificationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"successful_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSuccessfulVerificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"successful_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersSuccessfulVerificationPath(gon.current_organization.path, ...args);
  }

  return _usersSuccessfulVerificationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/skip_verification_for_now(.:format)`
 * - Path helper: `users_skip_verification_for_now_path`
 * - URL helper: `users_skip_verification_for_now_url`
 * - controller#action: `sessions#skip_verification_for_now`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSkipVerificationForNowPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSkipVerificationForNowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_for_now"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSkipVerificationForNowPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_for_now"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersSkipVerificationForNowPath(gon.current_organization.path, ...args);
  }

  return _usersSkipVerificationForNowPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/skip_verification_confirmation(.:format)`
 * - Path helper: `users_skip_verification_confirmation_path`
 * - URL helper: `users_skip_verification_confirmation_url`
 * - controller#action: `sessions#skip_verification_confirmation`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSkipVerificationConfirmationPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSkipVerificationConfirmationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSkipVerificationConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"skip_verification_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersSkipVerificationConfirmationPath(gon.current_organization.path, ...args);
  }

  return _usersSkipVerificationConfirmationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/fallback_to_email_otp(.:format)`
 * - Path helper: `users_fallback_to_email_otp_path`
 * - URL helper: `users_fallback_to_email_otp_url`
 * - controller#action: `sessions#fallback_to_email_otp`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersFallbackToEmailOtpPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersFallbackToEmailOtpPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"fallback_to_email_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersFallbackToEmailOtpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"fallback_to_email_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersFallbackToEmailOtpPath(gon.current_organization.path, ...args);
  }

  return _usersFallbackToEmailOtpPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/passkeys/sign_in(.:format)`
 * - Path helper: `users_passkeys_sign_in_path`
 * - URL helper: `users_passkeys_sign_in_url`
 * - controller#action: `sessions#new_passkey`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPasskeysSignInPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersPasskeysSignInPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _usersPasskeysSignInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersPasskeysSignInPath(gon.current_organization.path, ...args);
  }

  return _usersPasskeysSignInPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/sign_in_path(.:format)`
 * - Path helper: `users_sign_in_path_path`
 * - URL helper: `users_sign_in_path_url`
 * - controller#action: `sessions#sign_in_path`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSignInPathPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersSignInPathPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersSignInPathPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in_path"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersSignInPathPath(gon.current_organization.path, ...args);
  }

  return _usersSignInPathPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/auth(.:format)`
 * - Path helper: `users_auth_path`
 * - URL helper: `users_auth_url`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthPath = /*#__PURE__*/ (...args) => {
  const _organizationUsersAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _usersAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUsersAuthPath(gon.current_organization.path, ...args);
  }

  return _usersAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms/:id/accept(.:format)`
 * - Path helper: `accept_term_path`
 * - URL helper: `accept_term_url`
 * - controller#action: `users/terms#accept`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptTermPath = /*#__PURE__*/ (...args) => {
  const _acceptOrganizationTermPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _acceptTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _acceptOrganizationTermPath(gon.current_organization.path, ...args);
  }

  return _acceptTermPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms/:id/decline(.:format)`
 * - Path helper: `decline_term_path`
 * - URL helper: `decline_term_url`
 * - controller#action: `users/terms#decline`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineTermPath = /*#__PURE__*/ (...args) => {
  const _declineOrganizationTermPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _declineTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _declineOrganizationTermPath(gon.current_organization.path, ...args);
  }

  return _declineTermPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/terms(.:format)`
 * - Path helper: `terms_path`
 * - URL helper: `terms_url`
 * - controller#action: `users/terms#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsPath = /*#__PURE__*/ (...args) => {
  const _organizationTermsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _termsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationTermsPath(gon.current_organization.path, ...args);
  }

  return _termsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/callouts(.:format)`
 * - Path helper: `callouts_path`
 * - URL helper: `callouts_url`
 * - controller#action: `users/callouts#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _calloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationCalloutsPath(gon.current_organization.path, ...args);
  }

  return _calloutsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/group_callouts(.:format)`
 * - Path helper: `group_callouts_path`
 * - URL helper: `group_callouts_url`
 * - controller#action: `users/group_callouts#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCalloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"group_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _groupCalloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"group_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCalloutsPath(gon.current_organization.path, ...args);
  }

  return _groupCalloutsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/project_callouts(.:format)`
 * - Path helper: `project_callouts_path`
 * - URL helper: `project_callouts_url`
 * - controller#action: `users/project_callouts#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCalloutsPath = /*#__PURE__*/ (...args) => {
  const _organizationProjectCalloutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"project_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _projectCalloutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"project_callouts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationProjectCalloutsPath(gon.current_organization.path, ...args);
  }

  return _projectCalloutsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/broadcast_message_dismissals(.:format)`
 * - Path helper: `broadcast_message_dismissals_path`
 * - URL helper: `broadcast_message_dismissals_url`
 * - controller#action: `users/broadcast_message_dismissals#create`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const broadcastMessageDismissalsPath = /*#__PURE__*/ (...args) => {
  const _organizationBroadcastMessageDismissalsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"broadcast_message_dismissals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _broadcastMessageDismissalsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"broadcast_message_dismissals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationBroadcastMessageDismissalsPath(gon.current_organization.path, ...args);
  }

  return _broadcastMessageDismissalsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/users/pins(.:format)`
 * - Path helper: `pins_path`
 * - URL helper: `pins_url`
 * - controller#action: `users/pins#update`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pinsPath = /*#__PURE__*/ (...args) => {
  const _organizationPinsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _pinsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationPinsPath(gon.current_organization.path, ...args);
  }

  return _pinsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/calendar(.:format)`
 * - Path helper: `user_calendar_path`
 * - URL helper: `user_calendar_url`
 * - controller#action: `users#calendar`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userCalendarPath = /*#__PURE__*/ (...args) => {
  const _organizationUserCalendarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userCalendarPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserCalendarPath(gon.current_organization.path, ...args);
  }

  return _userCalendarPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/calendar_activities(.:format)`
 * - Path helper: `user_calendar_activities_path`
 * - URL helper: `user_calendar_activities_url`
 * - controller#action: `users#calendar_activities`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userCalendarActivitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationUserCalendarActivitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userCalendarActivitiesPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"calendar_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserCalendarActivitiesPath(gon.current_organization.path, ...args);
  }

  return _userCalendarActivitiesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/groups(.:format)`
 * - Path helper: `user_groups_path`
 * - URL helper: `user_groups_url`
 * - controller#action: `users#groups`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userGroupsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserGroupsPath(gon.current_organization.path, ...args);
  }

  return _userGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects(.:format)`
 * - Path helper: `user_projects_path`
 * - URL helper: `user_projects_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserProjectsPath(gon.current_organization.path, ...args);
  }

  return _userProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/contributed(.:format)`
 * - Path helper: `user_contributed_projects_path`
 * - URL helper: `user_contributed_projects_url`
 * - controller#action: `users#contributed`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userContributedProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserContributedProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userContributedProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserContributedProjectsPath(gon.current_organization.path, ...args);
  }

  return _userContributedProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/starred(.:format)`
 * - Path helper: `user_starred_projects_path`
 * - URL helper: `user_starred_projects_url`
 * - controller#action: `users#starred`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userStarredProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserStarredProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userStarredProjectsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserStarredProjectsPath(gon.current_organization.path, ...args);
  }

  return _userStarredProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects/contributed(.:format)`
 * - Path helper: `user_projects_contributed_path`
 * - URL helper: `user_projects_contributed_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProjectsContributedPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsContributedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userProjectsContributedPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserProjectsContributedPath(gon.current_organization.path, ...args);
  }

  return _userProjectsContributedPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/projects/starred(.:format)`
 * - Path helper: `user_projects_starred_path`
 * - URL helper: `user_projects_starred_url`
 * - controller#action: `users#projects`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userProjectsStarredPath = /*#__PURE__*/ (...args) => {
  const _organizationUserProjectsStarredPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userProjectsStarredPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserProjectsStarredPath(gon.current_organization.path, ...args);
  }

  return _userProjectsStarredPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/snippets(.:format)`
 * - Path helper: `user_snippets_path`
 * - URL helper: `user_snippets_url`
 * - controller#action: `users#snippets`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSnippetsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSnippetsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSnippetsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserSnippetsPath(gon.current_organization.path, ...args);
  }

  return _userSnippetsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/followers(.:format)`
 * - Path helper: `user_followers_path`
 * - URL helper: `user_followers_url`
 * - controller#action: `users#followers`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFollowersPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowersPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserFollowersPath(gon.current_organization.path, ...args);
  }

  return _userFollowersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/following(.:format)`
 * - Path helper: `user_following_path`
 * - URL helper: `user_following_url`
 * - controller#action: `users#following`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFollowingPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowingPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserFollowingPath(gon.current_organization.path, ...args);
  }

  return _userFollowingPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/exists(.:format)`
 * - Path helper: `user_exists_path`
 * - URL helper: `user_exists_url`
 * - controller#action: `users#exists`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userExistsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserExistsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"exists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userExistsPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"exists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserExistsPath(gon.current_organization.path, ...args);
  }

  return _userExistsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/activity(.:format)`
 * - Path helper: `user_activity_path`
 * - URL helper: `user_activity_url`
 * - controller#action: `users#activity`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userActivityPath = /*#__PURE__*/ (...args) => {
  const _organizationUserActivityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userActivityPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserActivityPath(gon.current_organization.path, ...args);
  }

  return _userActivityPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/follow(.:format)`
 * - Path helper: `user_follow_path`
 * - URL helper: `user_follow_url`
 * - controller#action: `users#follow`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFollowPath = /*#__PURE__*/ (...args) => {
  const _organizationUserFollowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userFollowPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserFollowPath(gon.current_organization.path, ...args);
  }

  return _userFollowPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/users/:username/unfollow(.:format)`
 * - Path helper: `user_unfollow_path`
 * - URL helper: `user_unfollow_url`
 * - controller#action: `users#unfollow`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUnfollowPath = /*#__PURE__*/ (...args) => {
  const _organizationUserUnfollowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userUnfollowPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserUnfollowPath(gon.current_organization.path, ...args);
  }

  return _userUnfollowPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:username.gpg(.:format)`
 * - Path helper: `user_gpg_keys_path`
 * - URL helper: `user_gpg_keys_url`
 * - controller#action: `users#gpg_keys`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGpgKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationUserGpgKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[3,"username"],[2,[8,"."],[2,[6,"gpg"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _userGpgKeysPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[8,"."],[2,[6,"gpg"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserGpgKeysPath(gon.current_organization.path, ...args);
  }

  return _userGpgKeysPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:username(.:format)`
 * - Path helper: `user_path`
 * - URL helper: `user_url`
 * - controller#action: `users#show`
 *
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPath = /*#__PURE__*/ (...args) => {
  const _organizationUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _userPath = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUserPath(gon.current_organization.path, ...args);
  }

  return _userPath(...args);
};

